import { APP_KEY_IDS } from "../constants/constants"


const initialAppState =
{
    [APP_KEY_IDS.ABOUT_SYSTEM]: false,
    [APP_KEY_IDS.FINDER]: false,
    [APP_KEY_IDS.HOME]: false,
    [APP_KEY_IDS.ABOUT_ME]: false,
    [APP_KEY_IDS.APP_STORE]: false,
    [APP_KEY_IDS.SAFARI]: false,
    [APP_KEY_IDS.GALLERY]: false,
    [APP_KEY_IDS.XCODE]: false,
    [APP_KEY_IDS.SPOTIFY]: false,
    [APP_KEY_IDS.SETTINGS]: false,
    [APP_KEY_IDS.MESSAGES]: false,
    [APP_KEY_IDS.MUSIC]: false,
    [APP_KEY_IDS.NOTES]: false,
    [APP_KEY_IDS.CAMERA]: false,
    [APP_KEY_IDS.CHROME]: false,
    [APP_KEY_IDS.DEV_SKILLS]: false,
    [APP_KEY_IDS.CONTACTS]: false,
    [APP_KEY_IDS.HELP]: true,
    [APP_KEY_IDS.MOBILE_SPOTIFY]: false,
    [APP_KEY_IDS.MOBILE_GALLERY]: false,
    [APP_KEY_IDS.MOBILE_BIXBY]: false,
    [APP_KEY_IDS.MOBILE_CAMERA]: false,
    [APP_KEY_IDS.MOBILE_CONTACTS]: false,
    [APP_KEY_IDS.MOBILE_GALAXY_STORE]: false,
    [APP_KEY_IDS.MOBILE_MAIL]: false,
    [APP_KEY_IDS.MOBILE_MESSAGES]: false,
    [APP_KEY_IDS.MOBILE_MUSIC]: false,
    [APP_KEY_IDS.MOBILE_SETTINGS]: false,
    [APP_KEY_IDS.MOBILE_BROWSER]: false,
    [APP_KEY_IDS.AUTH]: false,
    [APP_KEY_IDS.LOCK_SCREEN]: true,
}



const handleAppWindow = (state = initialAppState, action) => {

    switch (action.type) {
        case "closeAllApps":
            return {
                ...initialAppState,
                ["help"]:false,
                ["lock_screen"]:false
            }
        case "flipState":
            return {
                ...state,
                [action.key]: !state[action.key],
            }
        case "open":
            return {
                ...state,
                [action.key]: true
            }
        case "close":
            return {
                ...state,
                [action.key]: false
            }
        default: return state
    }

}



export default handleAppWindow;